import UpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fab from '@mui/material/Fab';

import { scrollBackToTop } from '@/utils/scrollBackToTop';

import { scrollUpButtonStyles as sx } from './ScrollUpButton.styles';
import { useScrollUpVisible } from './useScrollUpVisible';

export const ScrollUpButton = () => {
	const visible = useScrollUpVisible();

	const scrollToTop = () => {
		scrollBackToTop();
	};

	if (!visible) {
		return null;
	}

	return (
		<Fab
			onClick={scrollToTop}
			sx={sx.root}
			size='small'
			color='primary'
			id='scroll-up-button'
		>
			<UpIcon sx={sx.icon} />
		</Fab>
	);
};
